/* バリエーション別 画像フィルタ（Broadcast用）
   画像のalt(代替テキスト)に "variant--" 規約を入れると、選択中バリエーションの画像だけを表示します。
   例) variant--Forest Green
       variant--Hammok Color:Forest Green+Rainfly:Digital Camo
   "+"=AND / ":"の左=オプション名・右=値 / "|"以降はメモ(無視) */
(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    if (!document.querySelector('.product__slides')) return;

    if (!document.getElementById('vfilter-style')) {
      var st = document.createElement('style');
      st.id = 'vfilter-style';
      st.textContent = '[data-vfilter-hide]{display:none !important;}';
      document.head.appendChild(st);
    }

    function norm(s){ return (s || '').trim().toLowerCase(); }

    function hasConvention(){
      return [].some.call(document.querySelectorAll('.product__slide'), function (s) {
        var img = s.querySelector('img'); var a = img ? img.getAttribute('alt') : null;
        return a && a.indexOf('variant--') >= 0;
      });
    }

    function groupOf(alt){
      if (!alt) return null;
      var m = alt.indexOf('variant--'); if (m < 0) return null;
      return alt.slice(m + 9).split('|')[0].trim();
    }

    function selectedMap(){
      var map = {};
      document.querySelectorAll('[data-product-options] .selector-wrapper').forEach(function (w) {
        var nameEl = w.querySelector('.radio__legend__option-name') || w.querySelector('.radio__legend__label');
        var name = nameEl ? nameEl.textContent.trim() : '';
        var val = '';
        var c = w.querySelector('input:checked'); if (c) val = c.value;
        if (!val) { var po = w.querySelector('[data-popout-input]'); if (po) val = po.value; }
        if (!val) { var sv = w.querySelector('[data-selected-value]'); if (sv) val = sv.textContent; }
        if (name) map[name] = (val || '').trim();
      });
      return map;
    }

    function matches(group, map){
      if (group === null) return true;
      var nmap = {}, pool = [];
      Object.keys(map).forEach(function (k) { nmap[norm(k)] = norm(map[k]); pool.push(norm(map[k])); });
      return group.split('+').map(function (s) { return s.trim(); }).every(function (part) {
        var ci = part.indexOf(':');
        if (ci >= 0) {
          var on = norm(part.slice(0, ci)), ov = norm(part.slice(ci + 1));
          if (nmap[on] === ov) { var pi = pool.indexOf(ov); if (pi >= 0) pool.splice(pi, 1); return true; }
          return false;
        }
        var v = norm(part), pj = pool.indexOf(v); if (pj < 0) return false; pool.splice(pj, 1); return true;
      });
    }

    function visibleSlides(){
      return [].filter.call(document.querySelectorAll('.product__slide'), function (s) { return !s.hasAttribute('data-vfilter-hide'); });
    }

    function activate(slide){
      if (!slide) return;
      var mid = slide.getAttribute('data-media-id');
      var link = document.querySelector('[data-thumb-item] [data-thumb-link][data-media-id="' + mid + '"]');
      if (link) link.click();
    }

    function apply(){
      if (!hasConvention()) return;
      var map = selectedMap();
      var slides = [].slice.call(document.querySelectorAll('.product__slide'));
      var visible = [];
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        var show = matches(groupOf(img ? img.getAttribute('alt') : null), map);
        if (show) { s.removeAttribute('data-vfilter-hide'); visible.push(s.getAttribute('data-media-id')); }
        else { s.setAttribute('data-vfilter-hide', ''); }
      });
      document.querySelectorAll('[data-thumb-item]').forEach(function (t) {
        var l = t.querySelector('[data-thumb-link]');
        var mid = l ? l.getAttribute('data-media-id') : null;
        if (mid && visible.indexOf(mid) >= 0) t.removeAttribute('data-vfilter-hide');
        else t.setAttribute('data-vfilter-hide', '');
      });
      var active = document.querySelector('.product__slide.media--active');
      if (!active || active.hasAttribute('data-vfilter-hide')) {
        var vis = visibleSlides(); if (vis.length) activate(vis[0]);
      }
    }

    var timer;
    function debApply(){ clearTimeout(timer); timer = setTimeout(apply, 120); }

    apply();

    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-product-options]')) debApply(); }, true);
    document.addEventListener('click',  function (e) { if (e.target.closest && e.target.closest('[data-product-options]')) debApply(); }, true);

    var target = document.querySelector('product-info') || document.querySelector('main') || document.body;
    if (target) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].type === 'childList' && (muts[i].addedNodes.length || muts[i].removedNodes.length)) { debApply(); break; }
        }
      }).observe(target, { childList: true, subtree: true });
    }

    /* 矢印ナビ：表示中スライドだけを循環（最後→最初にループ、非表示は飛ばす） */
    document.addEventListener('click', function (e) {
      if (!hasConvention()) return;
      var next = e.target.closest && e.target.closest('[data-button-next]');
      var prev = e.target.closest && e.target.closest('[data-button-prev]');
      if (!next && !prev) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var vis = visibleSlides();
      if (vis.length <= 1) return;
      var active = document.querySelector('.product__slide.media--active');
      var idx = vis.indexOf(active); if (idx < 0) idx = 0;
      var ni = (idx + (next ? 1 : -1) + vis.length) % vis.length;
      activate(vis[ni]);
    }, true);

    /* 見張り：スワイプ等で非表示スライドがアクティブになったら、表示中スライドへ自動補正
       （スマホのスワイプで最後まで送った時に画像が消えるのを防ぎ、先頭へループさせる） */
    var slidesContainer = document.querySelector('.product__slides') || document.body;
    var correcting = false;
    new MutationObserver(function () {
      if (correcting || !hasConvention()) return;
      var active = document.querySelector('.product__slide.media--active');
      if (active && active.hasAttribute('data-vfilter-hide')) {
        correcting = true;
        var vis = visibleSlides();
        if (vis.length) activate(vis[0]);
        setTimeout(function () { correcting = false; }, 60);
      }
    }).observe(slidesContainer, { attributes: true, attributeFilter: ['class'], subtree: true });
  });
})();